import React, { useState } from "react";

import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";
// import { useJsEnabled } from "@racepointenergy/gatsby-theme-sitespark/src/hooks";

import { CheckboxLabel, CheckboxInput } from "components/CheckboxLabel";

import { formPropTypes } from "./prop-types";
import {
  FormPartial,
  Input,
  Title,
  StyledP2,
  Checkboxes,
  MergedGridRow,
} from "../styles";

export const BasicInfoForm = ({ base }) => {
  const [newConstruction, setNewConstruction] = useState(false);
  const [retrofit, setRetrofit] = useState(false);
  // const jsEnabled = useJsEnabled();
  // console.log("id, nextId, prevId", id, nextId, prevId);
  // console.log("newConstruction, retrofit", newConstruction, retrofit);
  return (
    <React.Fragment>
      <Title>Basic Info</Title>
      <StyledP2>
        For an accurate initial quote, please fill out this form as completely
        as you can.
      </StyledP2>
      <FormPartial>
        <Input
          placeholder="Project Name*"
          name={base("ProjectName")}
          required
          type="text"
        />
        <label htmlFor={base("ProjectName")} className="hideAccessible">
          {"Project Name"}
        </label>
        <MergedGridRow
          css={`
            @media screen and (min-width: ${getSize("tablet720")}) {
              grid-template-columns: 1fr 1fr;
            }
          `}
        >
          <Input
            placeholder="First Name*"
            name={base("FirstName")}
            required
            type="text"
          />
          <label htmlFor={base("FirstName")} className="hideAccessible">
            {"First Name"}
          </label>
          <Input
            placeholder="Last Name*"
            name={base("LastName")}
            required
            type="text"
          />
          <label htmlFor={base("LastName")} className="hideAccessible">
            {"Last Name"}
          </label>
        </MergedGridRow>
        <Input
          placeholder="Email*"
          name={base("Email")}
          required
          type="email"
        />
        <label htmlFor={base("Email")} className="hideAccessible">
          {"Email"}
        </label>
        <MergedGridRow
          css={`
            @media screen and (min-width: ${getSize("tablet720")}) {
              grid-template-columns: 60% 1fr;
            }
          `}
        >
          <Input placeholder="City*" name={base("City")} type="text" required />
          <label htmlFor={base("City")} className="hideAccessible">
            {"City"}
          </label>
          <Input
            placeholder="State*"
            name={base("State")}
            type="text"
            required
          />
          <label htmlFor={base("State")} className="hideAccessible">
            {"State"}
          </label>
        </MergedGridRow>
        <Input
          placeholder="Number of Breaker Panels*"
          name={base("NumberOfBreakerPanels")}
          required
          type="text"
        />
        <label
          htmlFor={base("NumberOfBreakerPanels")}
          className="hideAccessible"
        >
          {"Number of Breaker Panels?"}
        </label>
        <Input
          placeholder="Utility*"
          name={base("Utility")}
          required
          type="text"
        />
        <label htmlFor={base("Utility")} className="hideAccessible">
          {"Utility?"}
        </label>
      </FormPartial>
      <Title
        css={`
          margin-top: 22px;
          @media screen and (min-width: ${getSize("desktop1920")}) {
            margin-top: 26px;
          }
        `}
      >
        Project Type
      </Title>
      <Checkboxes>
        {/* <CheckboxRow> */}
        <CheckboxLabel>
          <CheckboxInput
            type="checkbox"
            onChange={isChecked => setNewConstruction(isChecked)}
            name={base("NewConstruction")}
            data-enzyme="new-construction-checkbox"
          />
          <span>{"New Construction"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput
            type="checkbox"
            onChange={isChecked => setRetrofit(isChecked)}
            name={base("RetrofitOrRenovation")}
            data-enzyme="retrofit-checkbox"
          />
          <span>{"Retrofit/Renovation"}</span>
        </CheckboxLabel>
        {/* </CheckboxRow> */}
        {/* <CheckboxRow> */}
        <CheckboxLabel>
          <CheckboxInput
            type="checkbox"
            disabled={!newConstruction && !retrofit}
            name={base("Residential")}
            data-enzyme="residential-checkbox"
          />
          <span>{"Residential"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput
            type="checkbox"
            disabled={!newConstruction && !retrofit}
            name={base("Commercial")}
            data-enzyme="commercial-checkbox"
          />
          <span>{"Commercial"}</span>
        </CheckboxLabel>
        {/* </CheckboxRow> */}
      </Checkboxes>
    </React.Fragment>
  );
};

BasicInfoForm.propTypes = formPropTypes;
